/**
 * The cover image to render for a folder or resource card, or null when there
 * is none.
 *
 * No stock image is substituted (MYN-343): the photos once used here showed
 * unrelated artwork in place of the resource's own. Covers are required on
 * create and edit, so a missing one is a legacy row; callers leave its image
 * area as a neutral surface.
 *
 * @param coverImageUrl - the cover image URL from the API, or null when unset
 * @returns the URL to put in `img src`, or null to render no image
 */
export function resourceCoverUrl(coverImageUrl: string | null | undefined): string | null {
  return coverImageUrl?.trim() ? coverImageUrl : null;
}
